module.exports = __webpack_public_path__ + "2db4d330eedea21e428828ab3bed35ac.png";